// extracted by mini-css-extract-plugin
export var active = "_ep-7";
export var container = "_ep-0";
export var evenWidth = "_ep-4";
export var large = "_ep-5";
export var outlet = "_ep-8";
export var slide = "_ep-2";
export var small = "_ep-6";
export var tab = "_ep-3";
export var tabs = "_ep-1";